import * as v1 from "./v1";
export const analytics = { v1 };
